<script lang="ts">

//import AppCompass from './components/AppCompass.vue'
import AppCompass from "@/components/AppCompass.vue";

//export default {
//export {
//  components: {
//    AppCompass
//  }
//}


import { Options, Vue } from 'vue-class-component';

import Game from "@/Game";

import { watch, onMounted, ref, computed } from "vue";
import { useWindowSize } from "@vueuse/core";


	let showCompass = false;
	
    const { width, height } = useWindowSize();

//const game = new Game(ref(), width, height, {showCompass});
const game = new Game(ref(), width, height, null);
//const game = new Game(ref(), width, height, {props});

//    const { width, height } = useWindowSize();
    const aspectRatio = computed(() => {
      game.setViewSize(width.value, height.value);
      return width.value / height.value;
    });

    watch(aspectRatio, (val) => {
      if (val) {
        game.updateCamera();
        game.updateRenderer();
      }
    });

//    onMounted(() => {
//      console.log("SceneView.onMounted, setCompass = " + {setCompass});
//      game.onMounted();
//    });

/*
@Options({
  props: {
    msg: String
  }
})
*/

/*
export default class SceneView extends Vue {
  msg!: string

//  buttonClick(buttonId: string) {
//    //console.log("SceneView.buttonClick, buttonId = " + buttonId);
//    game.buttonClick(buttonId);
//  },

  setup() {
    console.log("SceneView.setup");

    onMounted(() => {
      console.log("SceneView.onMounted");
      game.onMounted();

    });

    const webGl = ref();

    return { webGl };
  }

}
*/

export default {

//  buttonClick(buttonId: string) {
//    console.log("SceneView.buttonClick, buttonId = " + buttonId);
//    game.buttonClick(buttonId);
//  },

	props: {
		showCompass: {
			type: Boolean,
			default: false
		},
		
	},

	setup() {

		console.log("SceneView.setup");

		const webGl = ref();

		onMounted(() => {
		
//			console.log("SceneView.onMounted, setCompass = " + this.methods.setCompass);
//			console.log("SceneView.onMounted, setCompass = " + props);
			
			game.onMounted(webGl);

		});

		return { webGl };
	},

	methods: {
		buttonClick(buttonId: string) {
			console.log("SceneView.buttonClick_method, buttonId = " + buttonId);
			game.buttonClick(buttonId);
		}, 
		setCompass(show: boolean, angle: number) {
			showCompass = !showCompass;
		}
	},

	components: {
		AppCompass
	}

}

/*
export class SceneView extends Vue {

  msg!: string

  buttonClick(buttonId: string) {
    console.log("SceneView.buttonClick, buttonId = " + buttonId);
    game.buttonClick(buttonId);
  }

}
*/

//function buttonClick(buttonId: string) {
//  console.log("SceneView.buttonClick***, buttonId = " + buttonId);
//  game.buttonClick(buttonId);
//}

</script>


<template>
  <div class="hello">

	<div id="mainButtons" style="position: absolute; width: 400px; height: 700px; border: 1px solid #888; background: #040b; left: 300px; top: 20px; font-size: 17px; border-radius: 10px; text-align: left; padding: 10px; color: #eea;">
		<el-text style="--el-text-color: #fb0;">Режим</el-text>
      <hr>
      <br>
      <el-button plain @click="buttonClick('level_infinity_world_straight_road')">Дрэг</el-button>
      - заезд на короткую дистанцию по прямой
      <br>
      <br>
      <el-button plain @click="buttonClick('level_infinity_world')">Ралли</el-button>
      - заезд по извилистой трассе на длинную дистанцию
      <br>
      <br>
      <el-button plain @click="buttonClick('game_trophy')">Трофи</el-button>
      - заезд по пересечённой местности, нужно пройти контрольные точки
      <br>
      <br>
      <el-button plain @click="buttonClick('level_asteroid')">Пейнтбол</el-button>
      - бой на автомобилях, оборудованных краскопушками
      <br>
      <br>
      <el-button plain @click="buttonClick('level_asteroid')">Захват флага</el-button>
      - команды прячут флаги на пересечённой местности, затем ищут
      <br>
      <br>
      <el-button plain @click="buttonClick('caravan')">Караван</el-button>
      - свободный поиск лута в окрестностях своих владений; лут появляется с известной игроку периодичностью; если игрок вовремя не собрал, могут подобрать гости
      (т.е. мотивируем и игрока, и других игроков - гостей владения; гостям показываем не весь лут, чтобы хозяину не так обидно было)
      <br>
      <br>
      <el-button plain >Дерби</el-button>
      - сбрось всех соперников с закольцованной трассы
      <br>
      <br>
      <el-button plain @click="buttonClick('player_place')">Владение игрока</el-button>
      - неигровой режим (3D-фон для действий со своими машинами)
    </div>  

	<div id="gameSpecs" style="display: none; position: absolute; width: 450px; height: 200px; border: 1px solid #888; background: #040b; left: 300px; top: 20px; font-size: 24px; border-radius: 10px; text-align: left; padding: 10px; color: #fff;">
		<span id="gameSpecsName"></span>
		<hr>
		Статус:
		<br>
		<span id="gameSpecsStatus"></span>
		<br>
		<br>
		<span id = "gameSpecsControlPointDistanceCaption">Расстояние до контрольной точки:</span>
		<br> 
		<span id="gameSpecsControlPointDistance"></span>
		
		<br>
		<br>
		
    </div>  


	<div id="buttons" style="position: absolute; width: 200px; height: 140px; border: 1px solid #888; background: #040b; left: 20px; top: 130px; font-size: 17px; border-radius: 10px; text-align: left; padding: 10px;">
      <el-button plain @click="buttonClick('change_camera')">Камера</el-button>
      <br>
      <el-button plain @click="buttonClick('change_car_show_mode')">Физическая машина</el-button>
      <br>
      <el-button plain @click="buttonClick('change_terrain_show_mode')">Физическая поверхность</el-button>
      <br>
        <el-checkbox @click="buttonClick('change_auto_steering')" id="autoSteeringCheckbox" label="Авторуль" size="large" />
    </div>  


	<div id="engine" style="position: absolute; width: 200px; height: 500px; border: 1px solid #888; background: #040b; left: 20px; top: 300px; font-size: 17px; border-radius: 10px; text-align: left; padding: 10px;">
		<el-text style="--el-text-color: #fb0;">Сцепление: <span v-text="carClutch" id="carClutch"></span></el-text>
		<br>
		<el-text style="--el-text-color: #fb0;">Передача: <span v-text="carGear" id="carGear"></span></el-text>
		<br>
		<el-text style="--el-text-color: #fb0;">Скорость: <span v-text="carSpeed" id="carSpeed"></span></el-text>
		<br>
		<el-text style="--el-text-color: #fb0;">Обороты: <span v-text="carRpm" id="carRpm"></span></el-text>
		<br>
		<br>
		<el-text style="--el-text-color: #fb0;">Руль: <span v-text="steering" id="steering"></span></el-text>
		<br>
		<el-text style="--el-text-color: #fb0;">Авторуль: <span v-text="carAutoSteering" id="carAutoSteering"></span></el-text>
		<br>
		<br>
		<el-text style="--el-text-color: #fb0;">Направление: <span v-text="carVector" id="carVector"></span></el-text>
		<br>
		<el-text style="--el-text-color: #fb0;">Сила: <span v-text="carForce" id="carForce"></span></el-text>
		<br>
		<br>
		<el-text style="--el-text-color: #fb0;">Колёса: <span v-text="carWheels" id="carWheels"></span></el-text>
		
    </div>  


    <h1>{{ msg }}</h1>

<div id="info" style="position: absolute; width: 200px; height: 500px; border: 1px solid #888; background: #040b; right: 20px; top: 20px; font-size: 17px; border-radius: 10px; text-align: left; padding: 10px;">
		<el-text style="--el-text-color: #fb0;">ПозицияX: <span id="positionX"></span></el-text>
		<br>
		<el-text style="--el-text-color: #fb0;">ПозицияY: <span id="positionY"></span></el-text>
		<br>
		<el-text style="--el-text-color: #fb0;">ПозицияZ: <span id="positionZ"></span></el-text>
		<br>
		<br>
		<el-text style="--el-text-color: #fb0;">cellPhysX: <span id="cellPhysX"></span></el-text>
		<br>
		<el-text style="--el-text-color: #fb0;">cellPhysZ: <span id="cellPhysZ"></span></el-text>
		<br>
		<el-text style="--el-text-color: #fb0;">physSquares: <span id="physSquares"></span></el-text>
		<br>
		<br>
		<el-text style="--el-text-color: #fb0;">numPolygons: <span id="numPolygons"></span></el-text>
		<br>
		<br>
		<el-text style="--el-text-color: #fb0;">numPhysSquares: <span id="numPhysSquares"></span></el-text>
		<br>
		<el-text style="--el-text-color: #fb0;">numGraphSquares: <span id="numGraphSquares"></span></el-text>
		<br>
		<el-text style="--el-text-color: #fb0;">numSceneElements: <span id="numSceneElements"></span></el-text>
		<br>
		<el-text style="--el-text-color: #fb0;">numMapElements: <span id="numMapElements"></span></el-text>
		<br>
		<br>
		<el-text style="--el-text-color: #fb0;">numPhysWorldElements: <span id="numPhysWorldElements"></span></el-text>
		<br>
</div>


	<AppCompass id="compass" :degrees=0 v-show="showCompass" style="position: absolute; right: 0; top: 600px; width: 300px; height: 300px;"></AppCompass>

  </div>
  <canvas id="canvas" ref="webGl" class="webGl" style="z-index: -10; position: absolute; left: 0; top: 0; width: 100%; height: 100%;"/>
</template>



<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">


h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
